module.exports = __webpack_public_path__ + "img/药品网络交易第三方平台备案-加水印.73b23358.png";